import React from 'react';
import PropTypes from 'prop-types';

class Breadcrumb extends React.Component {
  render() {
    const { className, url, text } = this.props;

    return (
      <span className={className} itemScope itemType="http://data-vocabulary.org/Breadcrumb">
        <a itemProp="url" href={url}>
          <span itemProp="title">{text}</span>
        </a>
      </span>
    );
  }
}

Breadcrumb.defaultProps = {
  className: '',
  url: '#',
};

Breadcrumb.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
};

export default Breadcrumb;
